import { render, staticRenderFns } from "./OrganizationDepartmentsTable.vue?vue&type=template&id=711d410a&scoped=true"
import script from "./OrganizationDepartmentsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizationDepartmentsTable.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OrganizationDepartmentsTable.vue?vue&type=style&index=0&id=711d410a&prod&lang=css"
import style1 from "./OrganizationDepartmentsTable.vue?vue&type=style&index=1&id=711d410a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711d410a",
  null
  
)

export default component.exports